import { Component, Input } from "@angular/core";
import { Widget, FormProperty } from "./angular2-schema-form-shim";
import { JSONSchema, HelpTooltip, Help } from "./types/json-schema";

@Component( {
  selector: 'sp-widget-tooltip',
  templateUrl: './tooltip.component.html',
} )
export class WidgetTooltip {
  private static currentTooltip: WidgetTooltip = null;

  private _visible = false;

  @Input() public widget: Widget<FormProperty>;

  constructor() {
  }

  get self() {
    return <typeof WidgetTooltip>this.constructor;
  }

  get widgetHasTooltip(): boolean {
    return !!( this.tooltip && this.tooltip.body );
  }

  private get help(): Help {
    return ( <JSONSchema>this.widget.schema ).help || {};
  }

  get tooltip(): HelpTooltip {
    let help = this.help;
    return {
      title: null,
      body: typeof help.tooltip === 'string' ? help.tooltip : null,
      ...( typeof help.tooltip === 'object' ? help.tooltip : null ),
    };
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  get visible() {
    return this._visible;
  }

  set visible( newState ) {
    this.hideAll();
    this.self.currentTooltip = this;
    this._visible = newState;
  }

  hideAll() {
    if ( this.self.currentTooltip && this.self.currentTooltip != this ) {
      this.self.currentTooltip.hide();
      this.self.currentTooltip = null;
    }
  }

  toggle( $event: MouseEvent ) {
    $event.preventDefault();
    this.visible = !this.visible;
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/tooltip.component.ts